export default async function (context) {
    if (process.client) {
        if (context.$auth.strategy.refreshToken.status().expired()) {
            context.redirect('/Logout')
        }
    }
}
